var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('loyalty-header',{staticClass:"header"}),_c('magic-static-page-content',{staticClass:"loyalty-page-content",attrs:{"slug":"offers-loyalty-program","data-v-test-id":"loyalty-tiers"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }